import BroadcastInfo from './BroadcastInfo';

export default BroadcastInfo;
